import React, { useContext, useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { Button, Row, Container } from "react-bootstrap";
import { useLocation } from 'react-router-dom';
import { getSecurityCode } from "../redux/actions/checkInActions";
import Screen from '../components/Screen';
import QRCode from "react-qr-code";
import { HotelContext } from "../context/hotel";
import { UserContext } from "../context/user";
import { i18nValue } from '../functions';
import { T } from "react-translator-component";

const AddDevice = () => {
  const { sectionsByCode } = useContext(HotelContext)
  const { urlAddDevice, language } = useContext(UserContext);

  const [ url, setUrl ] = useState(false)

  // const { sections, data : { code : hotelCode } } = useSelector(state => state.hotelReducer);
  // const { checkIn : { id : checkInID } } = useSelector(state => state.checkInReducer);

  // useEffect(async () => {
  //   console.log('checkInID', checkInID)
  //   if (checkInID) {
  //     const r_securityCode = await getSecurityCode(checkInID)
  //     if (r_securityCode) {
  //       setSecurityCode(r_securityCode)
  //     }
  //   }


  // }, [checkInID])

  useEffect(() => {
    urlAddDevice().then(r => { 
      r = window.location.origin + r;
      setUrl(r) 
    })
  }, [])



    return (
      <Screen
        section="stay_add_device"
        title={i18nValue(sectionsByCode['stay_add_device'], 'title', language) || "Add Device"}
        description={i18nValue(sectionsByCode['stay_add_device'], 'desc', language)}
      >
          <p className="text-center text-muted mt-4">{T('stay.add-device-use-qr')}</p>
          <div style={{ textAlign: "center" }}>
            {url && <div style={{ background: '#FFF', borderColor: '#DDD', borderStyle: "solid", borderWidth: 1, padding: 15, display: "inline-block" }}>
              <QRCode value={url} />
            </div>}
            {/* {url && <small className="mt-2 d-block">{url}</small>} */}
            {!url && <div className="w-100 text-center mt-4"><div className="loading"><div className="spinner-border" role="status"></div></div></div>}
          </div>
        
        {/* <div className="page-footer">
          <Button  
            size={'lg'} 
            variant={'primary'} 
            type={'button'}
            block={true}
            onClick={() => {
              console.log('history', history)
              if (history.length > 1)
                history.goBack()
              else
                history.replace(`/${hotelCode}`)
            }}>
            Cerrar
          </Button>
        </div> */}
      </Screen>
    );
}

export default AddDevice;